import PropTypes from "prop-types";
import React from "react";

function BasicLoader(props) {
  const wrapperClass = `basic-loader ${props.className}`;

  return (
    <div className={wrapperClass}>
      <i className="fa fa-lg fa-cog fa-spin" />
      {props.children}
    </div>
  );
}

BasicLoader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

BasicLoader.defaultProps = {
  className: "",
  children: "Loading...",
};

export { BasicLoader };
